<template>
  <el-dialog
    title="升级包数据编辑窗口"
    :visible.sync="visible"
    width="1200px"
    @close="close">

    <el-form :inline="true" :model="DataUpgradeEditForm" label-position="right">
      <el-form-item label="观测号">
        <el-input v-model="DataUpgradeEditForm.obs_id" autocomplete="off" style="width:500px;"></el-input>
      </el-form-item>
      <el-form-item label="数据级别">
        <el-input v-model="DataUpgradeEditForm.level" autocomplete="off" style="width:500px;"></el-input>
      </el-form-item>
      <el-form-item label="数据版本">
        <el-input v-model="DataUpgradeEditForm.file_ver" autocomplete="off" style="width:180px;"></el-input>
      </el-form-item>
      <el-form-item label="生成时间">
        <el-date-picker v-model="DataUpgradeEditForm.archive_time" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="升级包文件">
        <el-input v-model="DataUpgradeEditForm.file_path" autocomplete="off" style="width:500px;"></el-input>
      </el-form-item>
      
      
      
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      DataUpgradeEditForm:{
        id:'', 
        obs_id:'', 
        level:'', 
        file_ver:'',
        archive_time:'',
        file_path:'',
      },

      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.DataUpgradeEditForm.id = data.id;
      this.DataUpgradeEditForm.obs_id = data.obs_id;
      this.DataUpgradeEditForm.level = data.level;
      this.DataUpgradeEditForm.file_ver = data.file_ver;
      this.DataUpgradeEditForm.archive_time = data.archive_time;
      this.DataUpgradeEditForm.file_path = data.file_path;   
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.DataUpgradeEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
